import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { SetCardLimitStackRoutes, SetCardLimitStackScreenProps } from './type';
import { SetCardLimitWebZeroScreen } from './SetCardLimitWebZero.screen';
import { SetCardLimitNativeZeroScreen } from './SetCardLimitNativeZero.screen';

export const SetCardLimitMain: React.FC<SetCardLimitStackScreenProps<SetCardLimitStackRoutes.Main>> = ({ navigation, route }) => {
  const { onLayout, account, tab, onDailyLimitType, record, func, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <SetCardLimitNativeZeroScreen
        onClose={onGoBack}
        onLayout={onLayout}
        onDailyLimitType={onDailyLimitType}
        account={account}
        tab={tab}
        record={record}
        func={func}
        refresh={refresh}
      />
    );
  }

  return (
    <SetCardLimitWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      onDailyLimitType={onDailyLimitType}
      account={account}
      tab={tab}
      record={record}
      func={func}
      refresh={refresh}
    />
  );
};
